export default __webpack_public_path__ + "static/1371-e1af621546c7f007a5e5dd473387ef8d.gif";